<template>
 <b-row class="slide-body bc-color">
        
        <b-row align-h="center"> 
            <h1 style="color:#ffffff"  v-if="$mq==='desktop'"><strong>{{ $t('slide12.text1') }}</strong></h1>
            <h3 style="color:#ffffff"  v-else><strong>{{ $t('slide12.text1') }}</strong></h3>
        </b-row>

        <b-row align-h="center"> 
            <b-col cols="1">
            </b-col>
            <b-col cols="10">
            <b-card class="text-center bc-color border-color" text-variant="white">               
                <b-row><b-card-text align="justify"><h3><strong>{{ $t('slide12.text2') }}</strong></h3></b-card-text></b-row>
                <b-row><b-card-text align="justify"><h3><strong>{{ $t('slide12.text3') }}</strong></h3></b-card-text></b-row>                
            </b-card>
            </b-col>
            <b-col cols="1">
            </b-col>
        </b-row>
     
        <b-row align-v="center" >
            <b-col cols="1">
            </b-col>
            <b-col cols="2">
                <h3 style="color:#ffffff"><strong>{{ $t('slide12.text4') }}</strong></h3>
            </b-col>
            <b-col cols="5">                    
                <h3 style="color:#ffffff"><strong>{{ $t('slide12.text5') }}</strong></h3>                    
            </b-col>                    
            <b-col cols="2">
                <h3 style="color:#ffffff"><strong>{{ $t('slide12.text6') }}</strong></h3>
            </b-col>
            <b-col cols="1">
            </b-col>
        </b-row>

        <b-row align-v="center" >
            <b-col cols="1">
            </b-col>
            <b-col cols="2">
                <b-alert show variant="light"><h5><strong>{{ $t('slide12.text7') }}</strong></h5></b-alert>
            </b-col>
            <b-col cols="5">                    
                <b-alert show variant="light"><h5><strong>{{ $t('slide12.text8') }}</strong></h5></b-alert>                    
            </b-col>                    
            <b-col cols="2">
                <b-input-group> 
                    <b-form-input size="lg" class="ml-5 mr-5 text-center" :value="slide12Process1" @input="updateVariable($event,'slide12Process1')" ></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="1">
            </b-col>
        </b-row>

        <b-row align-v="center" >  
            <b-col cols="1">
            </b-col>          
            <b-col cols="2">
                <b-alert show variant="light"><h5><strong>{{ $t('slide12.text9') }}</strong></h5></b-alert>
            </b-col>
            <b-col cols="5">                    
                <b-alert show variant="light"><h5><strong>{{ $t('slide12.text10') }}</strong></h5></b-alert>
            </b-col>                    
            <b-col cols="2">
               <b-input-group>
                    <b-form-input size="lg" class="ml-5 mr-5 text-center" :value="slide12Process2" @input="updateVariable($event,'slide12Process2')" ></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="1">
            </b-col>
        </b-row>

        <b-row align-v="center" >
            <b-col cols="1">
            </b-col>
            <b-col cols="2">
                <b-alert show variant="light"><h5><strong>{{ $t('slide12.text11') }}</strong></h5></b-alert>
            </b-col>
            <b-col cols="5">                    
                <b-alert show variant="light"><h5><strong>{{ $t('slide12.text12') }}</strong></h5></b-alert>                    
            </b-col>                    
            <b-col cols="2">
               <b-input-group>
                    <b-form-input size="lg" class="ml-5 mr-5 text-center" :value="slide12Process3" @input="updateVariable($event,'slide12Process3')" ></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="1">
            </b-col>
        </b-row>
    </b-row>
</template>

<script>
import {mapState} from 'vuex';

export default { 
    props:['lang'],   
    computed: {
        ...mapState(['slide12Process1','slide12Process2','slide12Process3']),
        pieces(){
            return this.$store.getters.getRandomPieces;
        }         
    },
    methods:{
        updateVariable(event, varName){
            this.$store.dispatch('updateVariable',{name: varName,value: event});
        },
    },
    beforeCreate(){       
        this.$store.dispatch('updateVariable',{name: 'showSendAnswer',value: false});
    },
    created(){
        this.$i18n.locale=this.lang;
        this.$emit('changeColor', 'bc-color'); 
    }        
}
</script>


<style scoped>

    .row{
        margin-left: 0px;
        margin-right: 0px;  
        width: 100%; 
    }

    .bc-color{
        background: #4e74e0;
    }

    .border-color{
        border: #4e74e0;
    }

    .text-center { 
        text-align: center; 
    }

</style>